// @flow

import ProjectClient from "../lib/apiClients/roofSnapApiClient/projectClient";
import { CALL_API } from "../middleware/api";
import {
    GET_PROJECT_DRAWING_SUMMARY_REQUEST, 
    GET_PROJECT_DRAWING_SUMMARY_SUCCESS, 
    GET_PROJECT_DRAWING_SUMMARY_FAILURE
} from "./actionTypes";

export const getProjectDrawingSummary = (id: string) => {
    const projectClient = new ProjectClient('v1');
    const request = projectClient.getProjectDrawingSummary;

    return {
        [CALL_API]: {
            types: [
                GET_PROJECT_DRAWING_SUMMARY_REQUEST,
                GET_PROJECT_DRAWING_SUMMARY_SUCCESS,
                GET_PROJECT_DRAWING_SUMMARY_FAILURE,
            ],
            request,
            params: {
                id
            }
        },
    };
};

